import axios from 'axios';
import { AuthState } from 'contexts/authContext';

async function login(username, password) {
  const url = 'Account/Authenticate';
  const request = {
    method: 'POST',
    url: url,
    headers: {
      'Content-Type': 'application/json',
    },
    data: { username, password },
  };

  const res = await axios(request);
  return res.data;
}

async function getNewToken() {
  const url = 'Account/GetToken';
  const request = {
    method: 'GET',
    url: url,
  };

  const res = await axios(request);
  return res.data;
}

async function getAccountDetails(token) {
  const url = 'Account/GetAccountDetails';
  const request = {
    method: 'GET',
    url: url,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const res = await axios(request);
  return res.data;
}

function getUsername() {
  if (AuthState && AuthState.user && AuthState.user.username) {
    return AuthState.user.username;
  }
  return '';
}

function getUserEmail() {
  if (AuthState && AuthState.user && AuthState.user.emailAddress) {
    return AuthState.user.emailAddress;
  }
  return '';
}

function getUserFirstName() {
  if (AuthState && AuthState.user && AuthState.user.firstName) {
    return AuthState.user.firstName;
  }
  return '';
}

function getUserLastName() {
  if (AuthState && AuthState.user && AuthState.user.lastName) {
    return AuthState.user.lastName;
  }
  return '';
}

function getUserFullName() {
  return getUserFirstName() + ' ' + getUserLastName();
}

function getUserField(field) {
  if (AuthState && AuthState.user) {
    return AuthState.user[field];
  }
  return null;
}




const UserService = {
  API: {
    login,
    getNewToken,
    getAccountDetails,
  },
  getUsername,
  getUserEmail,
  getUserFirstName,
  getUserLastName,
  getUserFullName,
  getUserField,
};

export default UserService;